import { init } from "echarts";

import { getDevInfoByProId, getDevTypeList, getDevAttrName } from "@/api/device";
import { getProNameList } from "@/api/project";
import { getPoliceList, getInsertPolice, getPoliceDel, getProByDeviceIdent, getPhoneByProject, getUpdatePolice, getPoliceState } from "@/api/warning";


const cityOptions = ['上海', '北京', '广州', '深圳'];
export default {
    name: "alarmRules",
    data() {
        return {

            selectVal: {//el-select的val
                allProject: '',
                // deviceType: '',
                deviceId: '',//设备ID
                device_id: '',//设备标识
                // attrIdent: '',
            },

            tableData: [],
            tableColumn: [
                {
                    id: '1',
                    prop: 'eventName',
                    label: '报警名称',
                    // sortable: "custom"
                }, {
                    id: '2',
                    prop: 'deviceName',
                    label: '设备名称',
                    // sortable: "custom"
                }, {
                    //     id: '3',
                    //     prop: 'deviceIdent',
                    //     label: '设备类型',
                    //     sortable: "custom"
                    // }, {
                    id: '4',
                    prop: 'triggers',
                    label: '触发条件'
                }, {
                    id: '5',
                    prop: 'eventLevelName',
                    label: '报警等级',
                    // sortable: "custom"
                }, {
                    //     id: '6',
                    //     prop: 'inform',
                    //     label: '通知方式'
                    // }, {
                    id: '7',
                    prop: 'sms',
                    label: '通知联系人'
                }, {
                    id: '10',
                    prop: 'proName',
                    label: '所属项目'
                }, {
                    id: '8',
                    prop: 'rulesState',
                    label: '规则状态',
                    xqliType: true
                }, {
                    id: '9',
                    prop: 'handle',
                    label: '操作',
                    xqliHandle: true
                },
            ],

            total: 0,
            pageSize: 20,
            page: 1,

            pupUp: false,
            warningRules: {
                warningName: '',
                projectName: '',
                proId: '',
                deviceType: 'name',
                deviceTypeName: '',
                deviceName: '',
                triggers: '',//触发条件
                level: '',
                checked: true,//通知方式
                proLinkMan: '',
                proLinkManPhone: "",
                organize_phone: '',
                organize_name: '',
                eventIdent: '',
                triggersArr: [{
                    triggers: '',
                    sign: '',
                    val: '',
                }]

            },
            rules: {
                warningName: [{ required: true, message: '请输入告警名称', trigger: 'blur' }, { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }],
                proId: [{ required: true, message: '请选择项目名称', trigger: 'change' }],
                deviceName: [{ required: true, message: '请选择设备', trigger: 'change' }],
                projectName: [{ required: true, message: '请选择项目名称', trigger: 'change' }],
                level: [{ required: true, message: '请选择告警等级', trigger: 'change' }],
            },

            triggersArr: [
                {
                    triggers: '',
                    sign: '',
                    val: '',
                }
            ],

            checkAll: false,
            checkedCities: ['上海', '北京'],
            cities: cityOptions,
            isIndeterminate: true,


            proNameList: [],
            devTypeList: [],
            deviceList: [],
            attrNameList: [],

            deviceListRule: [],
            attrNameListRule: [],

            order: "",
            sortBy: '',

            headTitle: '添加告警规则',
        }
    },
    computed: {

    },
    watch: {

    },
    created() {
        this.init()
    },
    mounted() {

    },
    methods: {

        init() {
            this.getProNameList()//项目list
            this.getPoliceList()//报警list
        },

        async getPoliceList() {
            let params = {
                page: this.page,
                offset: this.pageSize,
                sortBy: this.sortBy,
                order: this.order,

                projectId: this.selectVal.allProject, //项目id
                id: this.selectVal.deviceId, //设备id
                // deviceIdent: this.selectVal.device_id, //设备标识
                deviceIdent: this.selectVal.device_id ? [this.selectVal.device_id] : [], //设备标识
                // attrIdent: '' //属性标识（点位）
            }
            const res = await getPoliceList(params)

            if (res.code === 200) {
                this.total = res.data.total
                this.tableData = res.data.rows
                let deviceIdentList = []
                let proIdList = []
                this.tableData.map(item => {
                    deviceIdentList.push(item.deviceIdent)
                })
                deviceIdentList = [...new Set(deviceIdentList)]
                getProByDeviceIdent(deviceIdentList).then(res => {
                    res.data.map(item => {
                        this.tableData.map(val => {
                            if (item.deviceIdent === val.deviceIdent) {
                                this.$set(val, 'proName', item.proName)
                                this.$set(val, 'proId', item.id)
                            }
                        })
                        proIdList.push(item.id)
                    })
                    proIdList = [...new Set(proIdList)]
                    this.getPhoneByProject(proIdList)
                })
                // let proArr = res.data.proArr
                // let linkManArr = res.data.linkManArr
                // proArr.forEach(item => {
                //     linkManArr.forEach(el => {
                //         if (el.id === item.id) {
                //             item.contacts_name = el.contacts_name
                //             item.contacts_phone = el.contacts_phone
                //             item.organize_name = el.organize_name
                //             item.organize_phone = el.organize_phone
                //         }
                //     })
                //
                // })

                this.tableData.forEach(el => {
                    let eventLevelName = ''
                    switch (el.eventLevel) {
                        case 1:
                            eventLevelName = '低级'
                            break;
                        case 2:
                            eventLevelName = '中级'
                            break;
                        case 3:
                            eventLevelName = '高级'
                            break;
                    }
                    el.eventLevelName = eventLevelName

                    this.$set(el, 'rulesState', el.eventState === 0 ? true : false)

                    let trigAttr = el.trigAttr ? JSON.parse(el.trigAttr) : []
                    let trigAttrName = el.trigAttrName ? JSON.parse(el.trigAttrName) : []
                    let trigCondition = el.trigCondition ? JSON.parse(el.trigCondition) : []
                    let indexArr = this.findall(trigCondition || [], '%s')

                    el.dpName = trigAttrName[0] ? trigAttrName[0] : ''
                    el.dpId = trigAttr[0] ? trigAttr[0] : ''
                    el.sign = trigCondition[1] ? trigCondition[1] : ''
                    el.val = trigCondition[2] ? trigCondition[2] : ''
                    for (let i = 0; i < indexArr.length; i++) {
                        trigCondition.splice(indexArr[i], 1, trigAttrName[i])
                    }
                    el.triggers = trigCondition.join('')
                    // proArr.forEach(item => {
                    //     if (el.deviceIdent === item.deviceIdent) {
                    //         this.$set(el,'proName',item.proName)
                    //         el.proName = item.proName
                    //         el.proId = item.id
                    //
                    //         let name = ''
                    //         if (!item.contacts_phone && !item.organize_phone) {
                    //             name = ''
                    //         } else if (!item.contacts_phone) {
                    //             name = item.organize_name + '/' + item.organize_phone
                    //         } else if (!item.organize_phone) {
                    //             name = item.contacts_name + '/' + item.contacts_phone
                    //         } else {
                    //             name = item.contacts_name + '/' + item.contacts_phone + ';' + '\n' + item.organize_name + '/' + item.organize_phone
                    //         }
                    //         el.sms = name
                    //     }
                    // })
                })
            }
        },

        async getProNameList() {
            const res = await getProNameList()
            if (res.code == 200) {
                this.proNameList = res.data
            }
        },

        // async getDevTypeList() {
        //     const res = await getDevTypeList()
        //     if (res.code === 200) {
        //         this.devTypeList = res.data
        //     }
        // },

        handleAdd() {
            this.headTitle = '添加告警规则'
            this.pupUp = true
            this.deviceListRule = []
            this.attrNameListRule = []
            for (let k in this.warningRules) {
                this.warningRules[k] = ''
            }
            this.warningRules.triggersArr = [{
                triggers: '',
                sign: '',
                val: '',
            }]
            this.warningRules.deviceType = 'name'
            this.warningRules.checked = true
            for (let k in this.warningRules.triggersArr[0]) {
                this.warningRules.triggersArr[0][k] = ''
            }

        },

        async handleEdit(row) {
            this.headTitle = '编辑告警规则'
            this.pupUp = true

            // let phoneArr = row.sms.split(';')
            let phoneArr = row.sms.split(';')
            this.warningRules.warningName = row.eventName
            this.warningRules.projectName = row.proName
            this.warningRules.proId = row.proId ? Number(row.proId) : ''
            this.warningRules.deviceName = row.deviceIdent
            this.warningRules.eventIdent = row.eventIdent

            this.warningRules.triggersArr[0].triggers = row.dpId
            this.warningRules.triggersArr[0].sign = row.sign
            this.warningRules.triggersArr[0].val = row.val

            this.warningRules.level = row.eventLevel
            this.warningRules.proLinkMan = phoneArr[0] ? phoneArr[0].split('/')[0] : ''
            this.warningRules.proLinkManPhone = phoneArr[0] ? phoneArr[0].split('/')[1] : ''
            this.warningRules.organize_name = phoneArr[1] ? phoneArr[1].split('/')[0] : ''
            this.warningRules.organize_phone = phoneArr[1] ? phoneArr[1].split('/')[1] : ''

            this.getDevInfoByProIdRule()
            this.getDevAttrNameRule()
        },
        handleDelete(row) {
            this.$confirm('确认删除该条数据？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                getPoliceDel(row.eventIdent).then(res => {
                    if (res.code == 200) {
                        this.getPoliceList()
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                    }
                })
            })
        },

        changeCurrentPage(val) {
            this.page = val
            this.getPoliceList()
        },

        changeSize(val) {
            this.pageSize = val
            this.getPoliceList()
        },

        handleConfirm() {
            this.$refs.warningRules.validate((valid) => {
                if (valid) {
                    let sms = ''
                    if (this.warningRules.checked) {
                        sms = this.warningRules.proLinkManPhone + ';' + this.warningRules.organize_phone
                    }
                    let params = {
                        eventName: this.warningRules.warningName, //报警名称
                        // projectIds: [this.warningRules.projectName], //项目名称
                        deviceIdent: this.warningRules.deviceName, //设备标识
                        trigCondition: ["%s", this.warningRules.triggersArr[0].sign, this.warningRules.triggersArr[0].val], //触发条件
                        trigAttr: [this.warningRules.triggersArr[0].triggers], //条件参数，属性标识数组
                        eventLevel: this.warningRules.level, //事件等级，数值越大，等级越高,1：低，2：中，3：高
                        email: '',
                        sms: sms,
                    }

                    if (this.headTitle === '添加告警规则') {
                        getInsertPolice(params).then(res => {
                            if (res.code == 200) {
                                this.pupUp = false
                                this.getPoliceList()
                                this.$message({
                                    message: '新建成功',
                                    type: 'success'
                                });
                            }
                        })
                    } else if (this.headTitle === '编辑告警规则') {
                        params.eventIdent = this.warningRules.eventIdent
                        getUpdatePolice(params).then(res => {
                            if (res.code == 200) {
                                this.pupUp = false
                                this.getPoliceList()
                                this.$message({
                                    message: '修改成功',
                                    type: 'success'
                                });
                            }
                        })
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            })
        },
        handleCancel() {
            this.closePop()
        },



        handleClickRadioChange(val) {
            this.warningRules.deviceTypeName = ''
            this.warningRules.deviceName = ''

            this.attrNameListRule = []
            this.warningRules.triggersArr.forEach(el => {
                el.triggers = ''
                el.sign = ''
                el.val = ''
            })
        },

        handleCheckAllChange(val) {
            this.checkedCities = val ? cityOptions : [];
            this.isIndeterminate = false;
        },
        handleCheckedCitiesChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.cities.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
        },


        handleChangeProjectId(val) {//项目改变触发
            this.selectVal.device_id = ''
            this.page = 1
            this.getDevInfoByProId()//根据项目拿到设备list
            this.getPoliceList()
        },

        async getDevInfoByProId() {//设备名称
            let params = {
                projectId: this.selectVal.allProject
            }
            const res = await getDevInfoByProId(params)
            if (res.code === 200) {
                this.deviceList = res.data
            } else {
                this.deviceList = []
            }
        },


        handleChangeDevice(val) {//设备改变触发
            this.page = 1
            this.selectVal.deviceId = this.deviceList.filter(el => el.device_id === val)[0].id
            this.getPoliceList()
        },






        handleReset() {//重置按钮
            this.page = 1
            for (let k in this.selectVal) {
                this.selectVal[k] = null
            }
            this.deviceList = []
            this.getPoliceList()
        },

        handleSearch() {//查询按钮
            this.page = 1
            this.getPoliceList()
        },




        //添加用到的
        handleChangeProjectIdRule(val) {
            this.warningRules.deviceName = ''
            this.warningRules.triggersArr[0].triggers = ''
            this.warningRules.proId = val
            this.getDevInfoByProIdRule()//根据项目拿到设备list//getDevInfoByProId
            getPhoneByProject({ projectIds: [this.warningRules.proId] }).then(res => {
                if (res.code === 200) {
                    let data = res.data[0]
                    this.warningRules.proLinkMan = data.contacts_name
                    this.warningRules.proLinkManPhone = data.contacts_phone
                    this.warningRules.organize_phone = data.organize_phone
                    this.warningRules.organize_name = data.organize_name
                }
            })
        },

        async getDevInfoByProIdRule() {//设备名称
            let params = {
                projectId: this.warningRules.proId
            }
            const res = await getDevInfoByProId(params)
            if (res.code === 200) {
                this.deviceListRule = res.data
            } else {
                this.deviceListRule = []
            }
        },

        //根据项目ID 取项目联系人
        async getPhoneByProject(params) {
            const res = await getPhoneByProject({ projectIds: params })
            if (res.code === 200) {
                res.data.map(item => {
                    this.tableData.map(el => {
                        let name = ''
                        if (el.proId === item.id) {
                            // let contacts_name = item.contacts_name ? item.contacts_name + '/' : ''
                            // let organize_name = item.organize_name ? item.organize_name + '/' : ''
                            // let contacts_phone = item.contacts_phone ? item.contacts_phone + ';\n' : ''
                            // let organize_phone = item.organize_phone ? item.organize_phone : ''
                            // name = contacts_name + contacts_phone + organize_name +organize_phone

                            if (!item.contacts_phone && !item.organize_phone) {
                                name = ''
                            } else if (!item.contacts_phone) {
                                name = item.organize_name ? item.organize_name + '/' + item.organize_phone : item.organize_phone
                            } else if (!item.organize_phone) {
                                name = item.contacts_name ? item.contacts_name + '/' + item.contacts_phone : item.contacts_phone
                            } else  {
                                name = item.contacts_name + '/' + item.contacts_phone + ';' + '\n' + item.organize_name + '/' + item.organize_phone
                            }
                            this.$set(el, 'sms', name)
                        }
                    })
                })
            }
        },


        handleChangeDeviceName(val) {
            this.getDevAttrNameRule()//属性名称
        },
        async getDevAttrNameRule() {
            const res = await getDevAttrName(this.warningRules.deviceName)
            if (res.code == 200) {
                this.attrNameListRule = res.data
            }
        },


        async handleChangeSwitch(row) {
            let state = row.rulesState ? '0' : '1'
            let message = row.rulesState ? '已启用' : '已禁用'
            let type = row.rulesState ? 'success' : ''
            const res = await getPoliceState(row.eventIdent, state)
            if (res.code == 200) {
                this.$message({
                    message: message,
                    type: type
                });
            } else {
                this.$message({
                    message: '操作失败',
                    type: 'error'
                });
            }
        },







        handleSort(prop, order) {//排序
            this.sortBy = prop
            if (order === 'ascending') {//升序
                this.order = "asc"
            } else if (order === 'descending') {//降序
                this.order = 'desc'
            } else {
                this.order = ""
                this.sortBy = ''
            }
            this.getPoliceList()//发送请求
        },



        findall(a, x) {//查找数组中某个值出现的所有下标
            let results = [],
                len = a.length,
                pos = 0;
            while (pos < len) {
                pos = a.indexOf(x, pos);
                if (pos === -1) {//未找到就退出循环完成搜索
                    break;
                }
                results.push(pos);//找到就存储索引
                pos += 1;//并从下个位置开始搜索
            }
            return results;
        },
        closePop() {
            this.pupUp = false
            this.$refs.warningRules.resetFields()
        }
    },
}
